// 跳转链接集合
export const HOST = [
    'https://tradeup-dev.tigerfintech.com',
    'https://www.tradeup.com',
    'https://web-us-portal-qa.tigerbrokers.net'
];

export const API = {
    host: '',
    logout: '/logout',
    platform: '/platform',
    aboutus: '/aboutus',
    download: '/#download'
};
